import { motion } from 'framer-motion'
import { Button } from '../common/Button'
import { FiArrowRight } from 'react-icons/fi'

export const CTA = ({ onGetStarted }: { onGetStarted: () => void }) => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-primary-600 to-primary-700">
      <div className="container mx-auto max-w-4xl text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Pronto para começar?
          </h2>
          <p className="text-xl text-primary-100 mb-8">
            Junte-se a centenas de equipes que já estão usando o Projetoize para gerenciar seus projetos.
          </p>
          <Button
            onClick={onGetStarted}
            variant="secondary"
            size="lg"
            className="bg-white text-primary-600 hover:bg-gray-100 group"
          >
            Começar Agora
            <FiArrowRight className="ml-2 inline group-hover:translate-x-1 transition-transform" />
          </Button>
        </motion.div>
      </div>
    </section>
  )
}

